import { colors } from '@/constants';
import { ClockIcon } from 'public/Images';
import myImageLoader from '@/image.local.loader';
import React from 'react';
import Typography from '../typography/typography.component';
import useTranslationHook from '@/hook/use-translation-client.hook';

export enum ECarStatusBadge {
    PURCHASE_IN_PROGRESS = 'PURCHASE_IN_PROGRESS',
    RESERVED = 'RESERVED',
    NEWLY_ADDED = 'NEWLY_ADDED',
}

const StatusBadgeConfig = {
    [ECarStatusBadge.PURCHASE_IN_PROGRESS]: {
        label: 'purchaseInProgress.soldFlagMerge',
        textColor: colors['secondary-500'],
        color: colors['secondary-25'],
        hasIcon: false,
    },
    [ECarStatusBadge.RESERVED]: {
        label: 'reservedFor24h',
        textColor: colors['gray-700'],
        color: colors['gray-100'],
        hasIcon: false,
    },
    [ECarStatusBadge.NEWLY_ADDED]: {
        label: 'Newly Added',
        textColor: colors['warning-700'],
        color: colors['warning-50'],
        hasIcon: false,
    },
} as const;

interface CarStatusBadgeProps {
    isPurchaseInProgress: boolean;
    isReserved: boolean;
    isNewlyAdded: boolean;
}

const CarStatusBadge = ({
    isPurchaseInProgress,
    isReserved,
    isNewlyAdded,
}: CarStatusBadgeProps) => {
    const { t, IS_RTL } = useTranslationHook();

    let statusType: ECarStatusBadge | null = null;
    if (isPurchaseInProgress) {
        statusType = ECarStatusBadge.PURCHASE_IN_PROGRESS;
    } else if (isReserved) {
        statusType = ECarStatusBadge.RESERVED;
    } else if (isNewlyAdded) {
        statusType = ECarStatusBadge.NEWLY_ADDED;
    }

    if (!statusType) {
        return null;
    }

    const badgeData = StatusBadgeConfig[statusType];

    const getDisplayText = () => {
        if (statusType === ECarStatusBadge.NEWLY_ADDED) {
            return t('Newly Added');
        }
        return t(badgeData.label);
    };

    return (
        <div
            className={
                'absolute z-[2] top-0 ar:right-0 en:left-0 flex flex-row px-2 pt-1 pb-0.5 gap-1 justify-center items-center h-6 text-white'
            }
            style={{
                backgroundColor: badgeData.color,
                borderRadius: IS_RTL ? '0px 12px' : '12px 0px',
            }}
        >
            {badgeData.hasIcon && (
                <img
                    src={myImageLoader({
                        src: ClockIcon.src,
                        width: 12,
                        height: 12,
                    })}
                    alt="status-icon"
                />
            )}
            <Typography variant="caption2SemiBold" color={badgeData.textColor}>
                {getDisplayText()}
            </Typography>
        </div>
    );
};

export default CarStatusBadge;
